module.exports = __webpack_public_path__ + "static/super-simple-1686913cae7949d9be88fc47cce74fff.gif";